module.exports = __webpack_public_path__ + "static/img/hospital_logo.d82916d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hospital_logo.jpg
// module id = sT2k
// module chunks = 76